<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-tab
          :dense="true"
          type="pagetop"
          :tabItems.sync="tabItems"
          :inlineLabel="true"
          v-model="tab"
          align="left"
        >
          <template v-slot:default="tab">
            <component
              :is="tab.component"
            />
          </template>
        </c-tab>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'auth-group',
  data() {
    return {
      searchUrl: '',
      tab: 'codeMaster',
      tabItems: [
        { name: 'codeMaster', icon: 'list', label: '메뉴로그', component: () => import(`${'./menuLog001.vue'}`) },
        { name: 'codeGroup', icon: 'trending_up', label: '메뉴별 접속현황', component: () => import(`${'./menuLog002.vue'}`) },
        { name: 'codeGroup2', icon: 'trending_up', label: '기간별 업무 신규데이터 현황', component: () => import(`${'./menuLog003.vue'}`) },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
    },
  }
};
</script>
